import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error in component', { error, errorInfo });
  }

  render() {
    if (this.state.hasError) {
      return <div>Error loading component.</div>;
    }

    return this.props.children;
  }
}
